import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import GridContainer from '@jumbo/components/GridContainer';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    padding: 50,
  },
  coverName: {
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  progress: {
    width: '100%',
    marginBottom: 10,
  },
}));

const DownloadItem = () => {
  const history = useHistory();
  const classes = useStyles();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = channels => {
    // const channel = {
    //   name,
    // };
    history.push('/');
  };

  return (
    <React.Fragment>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
        <GridContainer className={classes.coverName}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="نام"
              multiline
              value={name}
              variant="outlined"
              onChange={e => setName(e.target.value)}
            />
          </Grid>
        </GridContainer>
        <GridContainer className={classes.coverName}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="لینک"
              multiline
              value={description}
              variant="outlined"
              onChange={e => setDescription(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="لینک کمکی"
              multiline
              value={description}
              variant="outlined"
              onChange={e => setDescription(e.target.value)}
            />
          </Grid>
        </GridContainer>
      </Box>
      <Box display="flex" justifyContent="flex-end" mb={4}>
        <Button onClick={() => history.push('/channel')}>لغو</Button>
        <Box ml={2}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            ثبت
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default DownloadItem;

DownloadItem.prototype = {
  selectedContact: PropTypes.object,
};

DownloadItem.defaultProps = {
  selectedContact: null,
};
